<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
// import {
//   addMonthForDate,
// } from '@qx/utils/index';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orderStateOptions: [], // 订单状态
        orderTypeOptions: [], // 订单类型
        orgIdOptions: [], // 归属部门
        vehicleClassOptions: [], // 车辆种类
        form: [
          { // 订单号码
            label: '订单号码',
            value: 'orderIds',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'DependTime',
            type: 'date',
            placeholder: '请输入发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 运输线路
            label: '运输线路',
            value: 'lineKey',
            type: 'input',
            placeholder: '请输入运输线路',
          },
          { // 订单状态
            label: '订单状态',
            value: 'orderState',
            type: 'select',
            default: -1,
            placeholder: '请选择订单状态',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 订单类型
            label: '订单类型',
            value: 'orderType',
            type: 'select',
            default: -1,
            placeholder: '请选择订单类型',
          },
          { // 客户单号
            label: '客户单号',
            value: 'customNumber',
            type: 'input',
            placeholder: '请输入客户单号',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
          },
          { // 车辆种类
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆种类',
          },
          { // 订单类别
            label: '订单类别',
            value: 'isHis',
            type: 'select',
            placeholder: '请选择订单类别',
            default: 0,
            options: [
              {
                label: '在途',
                value: 0,
              },
              {
                label: '历史',
                value: 1,
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    setDefalutDate () {
      // this.setFormAttrVal({
      //   form: this.searchBoxData,
      //   attr: 'default',
      //   value: [this.formatDate(addMonthForDate(null, -1)), ''],
      //   names: ['DependTime'],
      // });
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.DependTime && searchBoxData.DependTime.length > 0) {
        searchBoxData.beginDependTime = this.formatDate(searchBoxData.DependTime[0]);
        searchBoxData.endDependTime = this.formatDate(searchBoxData.DependTime[1]);
        delete searchBoxData.DependTime;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.setDefalutDate();
    const enumsList = await getEnumList({
      codeType: 'ORDER_STATE,ORDER_TYPE,VEHICLE_CLASS',
    });
    this.searchBoxData.orderStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.orderTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
